const IconType = Object.freeze({
  NONE: "NONE",
  PIN: "PIN",
  DOT: "DOT"
});
export default IconType;